export function resolveBrowserNetworkUrl(value) {
  const raw = String(value || '').trim();
  if (!raw || typeof window === 'undefined') return value;

  try {
    const url = new URL(raw);
    const configuredHost = url.hostname.toLowerCase();
    const pageHost = window.location.hostname;
    const configuredIsLoopback = configuredHost === 'localhost' || configuredHost === '127.0.0.1' || configuredHost === '::1' || configuredHost === '[::1]';
    const pageIsLoopback = pageHost === 'localhost' || pageHost === '127.0.0.1' || pageHost === '::1' || pageHost === '[::1]';

    if (configuredIsLoopback && !pageIsLoopback && pageHost) {
      url.hostname = pageHost;
      return url.toString();
    }
  } catch {
    return value;
  }

  return value;
}
